
import { mapGetters } from "vuex";
// import * as types from "../vuex/types";
// import api from "../vuex/api/index";

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  },
  head() {
    return {
      title: 'Our Team | Years of Lending Experience | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Our team at American Credit has years of FinTech business lending experience, that allows us to assist every individual with their unique business & goals.'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'small business loan team, Lei Li, Corey Rockafeler, Jun Mao, american credit'
        }
      ]
    }
  }
};
